var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hr'),_c('footer',{staticClass:"p-4 text-center align-items-center justify-content-center"},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" - Πόθεν Έσχες ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }